import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

import { magazineQueryLinkerSchema } from './magazine-query-linker-schema';

export const magazineQuerySchema = z.object({
  ...magazineQueryLinkerSchema.shape,
  status: statusQuerySchema,
  website: z.string().nullable(),
  clients_count: z.number(),
  icon: z.array(fileQuerySchema).nullish(),
});

export type MagazineQuerySchema = z.infer<typeof magazineQuerySchema>;

export const magazineQueryAllSchema = paginatedResponseSchema(magazineQuerySchema);
export type MagazineQueryAllSchema = z.infer<typeof magazineQueryAllSchema>;
